import { useEffect, useState } from 'react'

import { useGetCheckClientConsents } from 'components/pages/api'

export type MarketingConsents = {
  electronicProcessingAccepted: boolean
  phoneProcessingAccepted: boolean
  loanElectronicProcessingAccepted: boolean
  loanPhoneProcessingAccepted: boolean
  loan2ElectronicProcessingAccepted: boolean
  loan2PhoneProcessingAccepted: boolean
}
const initMarketingConsents = {
  electronicProcessingAccepted: false,
  phoneProcessingAccepted: false,
  loanElectronicProcessingAccepted: false,
  loanPhoneProcessingAccepted: false,
  loan2ElectronicProcessingAccepted: false,
  loan2PhoneProcessingAccepted: false,
}

interface CheckClientConsents {
  providedNip: string
}

export const useCheckClientConsents = ({ providedNip }: CheckClientConsents) => {
  const [marketingConsents, setMarketingConsents] = useState<MarketingConsents>(initMarketingConsents)

  const {
    data: clientConsentsData,
    isError: clientConsentsIsError,
    isFetching: clientConsentsIsLoading,
  } = useGetCheckClientConsents(providedNip)

  useEffect(() => {
    if (clientConsentsData) {
      setMarketingConsents({
        electronicProcessingAccepted: Boolean(clientConsentsData?.electronicProcessingAccepted),
        phoneProcessingAccepted: Boolean(clientConsentsData?.phoneProcessingAccepted),
        loanElectronicProcessingAccepted: Boolean(clientConsentsData?.loanElectronicProcessingAccepted),
        loanPhoneProcessingAccepted: Boolean(clientConsentsData?.loanPhoneProcessingAccepted),
        loan2ElectronicProcessingAccepted: Boolean(clientConsentsData?.loan2ElectronicProcessingAccepted),
        loan2PhoneProcessingAccepted: Boolean(clientConsentsData?.loan2PhoneProcessingAccepted),
      })
    } else if (clientConsentsIsError) {
      setMarketingConsents(initMarketingConsents)
    }
  }, [clientConsentsData, clientConsentsIsError])

  return { marketingConsents, clientConsentsIsLoading }
}
